/**
 * NumberField Component
 *
 * number 타입 필드를 렌더링하는 컴포넌트
 * shadcn/ui Input 컴포넌트 사용 (type="number")
 * min, max, step 속성 지원
 */

import { Input } from '@/shared/ui/input';

import type { BaseFieldProps } from './types';

/**
 * 숫자 입력 필드
 *
 * FormField의 min, max, step 속성을 HTML input의 속성으로 전달
 * 값 변경 시 Number로 변환하여 전달
 */
export function NumberField({ field, value, onChange, disabled, error }: BaseFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <Input
        id={field.id}
        name={field.name}
        type="number"
        placeholder={field.placeholder}
        disabled={disabled}
        autoComplete="off"
        className="h-12 px-4 py-3"
        min={field.min}
        max={field.max}
        step={field.step}
        onChange={(e) => {
          const numValue = e.target.value === '' ? '' : Number(e.target.value);
          onChange(numValue);
        }}
        value={value === '' || value === undefined ? '' : String(value)}
        aria-invalid={!!error}
      />
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}
